'use client';

import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

//Keep only Hls here no dash for web

type Props = {
  src?: string;
  poster?: string;
};

const VideoPlayer: React.FC<Props> = ({ src, poster }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) {
      console.warn('⚠️ VideoPlayer: videoRef is not ready');
      return;
    }

    if (!src) {
      console.warn('⚠️ VideoPlayer: src is empty');
      return;
    }

    let hls: Hls | null = null;

    try {
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src;
        video.load();
      } else if (Hls.isSupported()) {
        hls = new Hls({
          enableWorker: true,
          lowLatencyMode: false,
          backBufferLength: 30,
        });

        hls.loadSource(src);
        hls.attachMedia(video);

        hls.on(Hls.Events.ERROR, (_event, data) => {
          console.error('[HLS ERROR]', data);
        });
      } else {
        console.error('❌ HLS not supported in this browser.', { src });
      }
    } catch (err) {
      console.error('❌ Video init failed', err);
    }

    return () => {
      try {
        if (hls) {
          hls.destroy();
        }

        video.pause();
        video.removeAttribute('src');
        video.load();
      } catch {}
    };
  }, [src]);

  return (
    <video
      ref={videoRef}
      controls
      autoPlay
      muted
      playsInline
      poster={poster}
      style={{ width: '100%', borderRadius: 8, backgroundColor: '#000' }}
    />
  );
};

export default VideoPlayer;